import type {
  HubFileEncoding,
  HubFileValue,
} from '@robovision/hub'


export interface FileValueParams {
  data: string
  encoding: HubFileEncoding
  mimeType: string
}

export class FileValue {
  public readonly data: string
  public readonly encoding: HubFileEncoding
  public readonly mimeType: string


  public constructor (params: FileValueParams) {
    this.data = params.data
    this.encoding = params.encoding
    this.mimeType = params.mimeType

    Object.freeze(this)
  }

  public static fromResponse (data: HubFileValue) {
    return new FileValue({
      data: data.data,
      encoding: data.encoding,
      mimeType: data.mimeType,
    })
  }
}
